import { useTranslation } from 'react-i18next';

import { usePaymentCardType } from '@/features/cards/hooks/usePaymentCardType';
import { IPaymentCard } from '@/features/cards/store/models/card.model';

export function CardType({ paymentCard }: { paymentCard: IPaymentCard }) {
  const paymentCardType = usePaymentCardType(paymentCard);
  const { t } = useTranslation();
  return (
    <span className="typo-body-regular-small">
      {t(`pages.currentProfiles.cards.card.cardPaymentTypes.${paymentCardType}`)}
    </span>
  );
}
